import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import "./howItWorksModal.css";

/**
 * Reusable "How It Works" modal.
 *
 * @param {boolean} show - Whether the modal is visible
 * @param {function} onHide - Called when the modal should close
 * @param {string} title - Modal header title
 * @param {Array<{ icon: string, title: string, description: string|React.ReactNode }>} features - List of feature items
 */
const HowItWorksModal = ({ show, onHide, title, features }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="how-it-works-modal-wrapper"
    >
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-1 px-2">
          <div className="d-flex flex-column gap-4 p-0">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="d-flex align-items-start gap-3"
              >
                <div className="d-flex align-items-center justify-content-center">
                  <Icon
                    path={feature.icon}
                    size={1}
                    className="text-primary mt-1"
                  />
                </div>
                <div>
                  <h5 className="how-it-works-feature-title">
                    {feature.title}
                  </h5>
                  <p className="how-it-works-feature-description">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={onHide}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default HowItWorksModal;
